module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/davita-7eb9787a22a336423ea31ac815f0aee7.png";